import { TagSimpleIcon as PhosphorTagSimpleIcon } from "@phosphor-icons/react/dist/ssr/TagSimple";

import { createAppIcon } from "@/components/createAppIcon";

export const LabelIcon = /* @__PURE__ */ createAppIcon(PhosphorTagSimpleIcon);
